<template>
  <div class="page-content">
    <div class="page-header">
      <div>
        <BreadcrumbComponent :items="items" />
        <h1 class="page-title">Consommation d'ingrédients</h1>
        <p class="page-subtitle" v-if="rows.length">{{ rows.length }} ingrédient{{ rows.length > 1 ? 's' : '' }} consommé{{ rows.length > 1 ? 's' : '' }}</p>
      </div>
      <div class="d-flex" style="gap: 8px;">
        <v-select
          :items="stores"
          item-value="id"
          item-text="name"
          placeholder="Tous les emplacements"
          prepend-inner-icon="mdi-store-outline"
          v-model="store_id"
          outlined dense hide-details clearable
          style="max-width: 220px;"
          @change="load"
        ></v-select>
        <v-btn color="error" outlined small @click="exportPDF" v-if="rows.length"><v-icon left small>mdi-file-pdf-box</v-icon>PDF</v-btn>
        <v-btn color="success" outlined small @click="exportExcel" v-if="rows.length"><v-icon left small>mdi-file-excel</v-icon>Excel</v-btn>
      </div>
    </div>

    <PreloaderComponent :enable="enable" />

    <div v-if="enable">
      <v-row class="mb-2">
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#194173"><v-icon color="white" size="18">mdi-food-variant</v-icon></div>
            <div class="summary-val">{{ rows.length }}</div>
            <div class="summary-lbl">Ingrédients consommés</div>
          </v-card>
        </v-col>
        <v-col cols="6" md="3">
          <v-card flat class="summary-card">
            <div class="summary-icon-sm" style="background:#f68d3b"><v-icon color="white" size="18">mdi-cash</v-icon></div>
            <div class="summary-val">{{ fmt(totalCost) }}</div>
            <div class="summary-lbl">Coût total consommé</div>
          </v-card>
        </v-col>
      </v-row>

      <div class="d-flex justify-end mb-3">
        <input v-model="search" type="text" placeholder="Rechercher..." class="search-input" />
      </div>

      <v-card flat class="table-card">
        <div class="table-responsive">
          <table class="report-table">
            <thead>
              <tr>
                <th class="text-left">INGRÉDIENT</th>
                <th class="text-left">UNITÉ</th>
                <th class="text-right">QUANTITÉ CONSOMMÉE</th>
                <th class="text-right">COÛT UNITAIRE</th>
                <th class="text-right">COÛT TOTAL</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(r, idx) in filteredRows" :key="idx">
                <td class="font-weight-medium">{{ r.name }}</td>
                <td>{{ r.unit }}</td>
                <td class="text-right">{{ fmt(r.total_consumed) }}</td>
                <td class="text-right">{{ fmt(r.cost) }}</td>
                <td class="text-right font-weight-bold">{{ fmt(r.total_cost) }}</td>
              </tr>
              <tr v-if="filteredRows.length === 0">
                <td colspan="5" class="text-center text--secondary pa-6">Aucune donnée</td>
              </tr>
            </tbody>
          </table>
        </div>
      </v-card>
    </div>
  </div>
</template>

<script>
import BreadcrumbComponent from '../components/BreadcrumbComponent.vue'
import PreloaderComponent from '../components/PreloaderComponent.vue'

export default {
  name: 'IngredientsReportView',
  components: { BreadcrumbComponent, PreloaderComponent },
  data: () => ({
    items: [{ text: 'Consommation', disabled: true, href: '/ingredients-report' }],
    enable: false,
    search: '',
    rows: [],
    stores: [],
    store_id: null,
  }),
  computed: {
    filteredRows() {
      if (!this.search.trim()) return this.rows
      var q = this.search.toLowerCase()
      return this.rows.filter(function (r) { return r.name && r.name.toLowerCase().indexOf(q) !== -1 })
    },
    totalCost() { return this.filteredRows.reduce(function (s, r) { return s + parseFloat(r.total_cost || 0) }, 0) },
  },
  methods: {
    fmt(v) { var n = parseFloat(v); if (!n && n !== 0) return '0.00'; var p = Math.abs(n).toFixed(2).split('.'); p[0] = p[0].replace(/\B(?=(\d{3})+(?!\d))/g, ' '); return (n < 0 ? '-' : '') + p.join('.') },
    load() {
      var self = this
      var isValid = function (v) { return v && v !== 'null' && v.trim() !== '' }
      var from = isValid(localStorage.debut_periode) ? localStorage.debut_periode : ''
      var to = isValid(localStorage.fin_periode) ? localStorage.fin_periode : ''
      var url = '/reports/ingredient_consumption?from_date=' + from + '&to_date=' + to
      if (this.store_id) url += '&store_id=' + this.store_id
      this.$axios.get(url)
        .then(function (r) { self.rows = (r.data && r.data.result) || []; self.enable = true })
        .catch(function () { self.enable = true })
    },
    loadStores() {
      var self = this
      try {
        var biz = JSON.parse(localStorage.business)
        this.$axios.get('/stores?orderasc=name&business_id=' + biz.id)
          .then(function (r) { self.stores = r.data || [] })
      } catch (e) { /* ignore */ }
    },

    async exportPDF() {
      var self = this
      var { jsPDF } = await import('jspdf')
      var doc = new jsPDF('p', 'mm', 'a4')
      var pw = 210, ph = 297, ml = 12, mr = pw - 12, cw = mr - ml
      var biz = {}; try { biz = JSON.parse(localStorage.business) || {} } catch (e) { biz = {} }
      var primary = [25, 65, 115], dark = [30, 41, 59], muted = [100, 116, 139], border = [220, 225, 230], light = [248, 250, 252]

      doc.setFillColor(...primary); doc.rect(0, 0, pw, 18, 'F')
      doc.setFontSize(12); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255)
      doc.text('CONSOMMATION D\'INGRÉDIENTS', ml, 11)
      doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(200, 215, 235)
      doc.text((localStorage.debut_periode || '') + ' — ' + (localStorage.fin_periode || ''), mr, 8, { align: 'right' })
      if (biz.name) doc.text(biz.name, mr, 13, { align: 'right' })

      var y = 24
      var cols = [
        { label: 'INGRÉDIENT', w: 65, align: 'left' },
        { label: 'UNITÉ', w: 20, align: 'left' },
        { label: 'QTÉ CONSOMMÉE', w: 38, align: 'right' },
        { label: 'COÛT UNIT.', w: 30, align: 'right' },
        { label: 'COÛT TOTAL', w: 33, align: 'right' },
      ]
      var totalW = cols.reduce(function (s, c) { return s + c.w }, 0)
      var scale = cw / totalW; cols.forEach(function (c) { c.w = Math.round(c.w * scale) })
      var actualW = cols.reduce(function (s, c) { return s + c.w }, 0); cols[0].w += (cw - actualW)
      var cx = ml; cols.forEach(function (c) { c.x = cx; cx += c.w })
      var rowH = 7

      function drawHeader() {
        doc.setFillColor(...primary); doc.rect(ml, y, cw, rowH + 1, 'F')
        doc.setFontSize(7); doc.setFont('helvetica', 'bold'); doc.setTextColor(255, 255, 255)
        cols.forEach(function (c) { var tx = c.align === 'right' ? c.x + c.w - 3 : c.x + 3; doc.text(c.label, tx, y + 5, { align: c.align }) })
        y += rowH + 1
      }
      drawHeader()

      self.filteredRows.forEach(function (r, idx) {
        if (y + rowH > ph - 22) { doc.addPage(); y = 12; drawHeader() }
        if (idx % 2 === 0) { doc.setFillColor(250, 251, 253); doc.rect(ml, y, cw, rowH, 'F') }
        doc.setDrawColor(...border); doc.setLineWidth(0.1); doc.line(ml, y + rowH, mr, y + rowH)
        doc.setFontSize(8); doc.setFont('helvetica', 'normal'); doc.setTextColor(...dark)
        var name = r.name || ''; if (name.length > 38) name = name.substring(0, 36) + '..'
        var vals = [name, r.unit || '', self.fmt(r.total_consumed), self.fmt(r.cost), self.fmt(r.total_cost)]
        cols.forEach(function (c, i) {
          var tx = c.align === 'right' ? c.x + c.w - 3 : c.x + 3
          doc.text(vals[i], tx, y + 4.8, { align: c.align })
        })
        y += rowH
      })

      // Totals
      y += 1; doc.setFillColor(...light); doc.rect(ml, y, cw, rowH + 1, 'F')
      doc.setDrawColor(...primary); doc.setLineWidth(0.4); doc.line(ml, y, mr, y)
      doc.setFontSize(8); doc.setFont('helvetica', 'bold'); doc.setTextColor(...dark)
      doc.text('TOTAL', ml + 3, y + 5)
      doc.text(self.fmt(self.totalCost), cols[4].x + cols[4].w - 3, y + 5, { align: 'right' })

      var totalPages = doc.internal.getNumberOfPages()
      for (var p = 1; p <= totalPages; p++) {
        doc.setPage(p); doc.setDrawColor(...border); doc.setLineWidth(0.2); doc.line(ml, ph - 10, mr, ph - 10)
        doc.setFontSize(6); doc.setFont('helvetica', 'bold'); doc.setTextColor(...primary); doc.text('KES LAKAY', ml, ph - 6)
        doc.setFont('helvetica', 'normal'); doc.setTextColor(...muted); doc.text('Page ' + p + ' / ' + totalPages, pw / 2, ph - 6, { align: 'center' })
        var now = new Date(); doc.text(now.toLocaleDateString('fr-FR') + ' ' + now.toLocaleTimeString('fr-FR', { hour: '2-digit', minute: '2-digit' }), mr, ph - 6, { align: 'right' })
      }
      doc.save('consommation_ingredients.pdf')
    },

    exportExcel() {
      var self = this
      var XLSX = require('xlsx')
      var biz = {}; try { biz = JSON.parse(localStorage.business) || {} } catch (e) { biz = {} }
      var wsData = [['CONSOMMATION D\'INGRÉDIENTS'], [biz.name || ''], ['Du ' + (localStorage.debut_periode || '') + ' au ' + (localStorage.fin_periode || '')], []]
      wsData.push(['Ingrédient', 'Unité', 'Quantité consommée', 'Coût unitaire', 'Coût total'])
      self.filteredRows.forEach(function (r) {
        wsData.push([r.name, r.unit, parseFloat(r.total_consumed || 0), parseFloat(r.cost || 0), Math.round(parseFloat(r.total_cost || 0) * 100) / 100])
      })
      wsData.push([])
      wsData.push(['TOTAL', '', '', '', Math.round(self.totalCost * 100) / 100])
      var wb = XLSX.utils.book_new(); var ws = XLSX.utils.aoa_to_sheet(wsData)
      ws['!cols'] = [{ wch: 32 }, { wch: 10 }, { wch: 18 }, { wch: 14 }, { wch: 16 }]
      ws['!autofilter'] = { ref: XLSX.utils.encode_range({ s: { r: 4, c: 0 }, e: { r: 4, c: 4 } }) }
      ws['!merges'] = [{ s: { r: 0, c: 0 }, e: { r: 0, c: 4 } }, { s: { r: 1, c: 0 }, e: { r: 1, c: 4 } }, { s: { r: 2, c: 0 }, e: { r: 2, c: 4 } }]
      for (var r = 5; r < wsData.length; r++) { var c = 4; var cell = ws[XLSX.utils.encode_cell({ r: r, c: c })]; if (cell && typeof cell.v === 'number') { cell.t = 'n'; cell.z = '#,##0.00' } }
      XLSX.utils.book_append_sheet(wb, ws, 'Consommation'); XLSX.writeFile(wb, 'consommation_ingredients.xlsx')
    },
  },
  mounted() { this.load(); this.loadStores() },
}
</script>

<style scoped>
.summary-card { border: 1px solid #e8ecf1 !important; border-radius: 10px !important; padding: 16px; text-align: center; }
.summary-icon-sm { width: 36px; height: 36px; border-radius: 8px; display: inline-flex; align-items: center; justify-content: center; margin-bottom: 8px; }
.summary-val { font-size: 1.125rem; font-weight: 700; color: #1a2332; }
.summary-lbl { font-size: 0.75rem; color: #64748b; margin-top: 2px; }
.search-input { width: 260px; padding: 8px 12px; font-size: 0.8125rem; border: 1px solid #cbd5e1; border-radius: 6px; outline: none; }
.search-input:focus { border-color: #194173; box-shadow: 0 0 0 2px rgba(25, 65, 115, 0.1); }
.table-card { border: 1px solid #e8ecf1 !important; border-radius: 8px !important; overflow: hidden; }
.table-responsive { overflow-x: auto; max-height: 600px; overflow-y: auto; }
.report-table { width: 100%; border-collapse: collapse; font-size: 0.8125rem; }
.report-table thead th { position: sticky; top: 0; background: #f8fafc; font-weight: 600; font-size: 0.6875rem; text-transform: uppercase; letter-spacing: 0.05em; color: #64748b; padding: 12px; border-bottom: 2px solid #e8ecf1; white-space: nowrap; z-index: 1; }
.report-table tbody td { padding: 10px 12px; border-bottom: 1px solid #f1f5f9; white-space: nowrap; }
</style>
